import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import '../src/styles/site.scss';
import App from './routes/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import CustomCookieConsent from './components/CookieConsent/CustomCookieConsent';
import { AppContextProvider } from './components/contextAPI/AppContext';

// Optional: Set initial data for the context
const initialContextData = {
  buttonLink: {
    buttonImage: null,
    buttonLink: null,
    buttonText: null,
    buttonType: null
  },
  title: null
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppContextProvider initialData={initialContextData}>
        <App />
        <CustomCookieConsent />
      </AppContextProvider>
    </BrowserRouter>
  </React.StrictMode>,
);